
      import CaretBottom from './caret-bottom.vue'
      import type { App, Plugin } from 'vue'

      export const CaretBottomPlugin: Plugin = {
        install(app: App) {
          app.component('CaretBottom', CaretBottom)
        },
      }
      export { CaretBottom }
      